class Controller {
  constructor($injector, $stateParams, $mdDialog, Sections) {
    "ngInject";

    this.$stateParams = $stateParams;
    this.sections = Sections.settingsSections;

    this.$mdDialog = $mdDialog;
    this.Events = $injector.get("Events");
    this.Ticket = $injector.get("Ticket");
    this.TicketTransforms = $injector.get("TicketTransforms");
  }

  $onInit() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const getConfirmDialog = (title, confirmClick) =>
      this.$mdDialog
        .confirm()
        .title(title)
        .ok(confirmClick || "Ok")
        .cancel("Cancel");

    this.Ticket.get(this.$stateParams.id).$promise.then((response) => {
      this.ticket = this.TicketTransforms.justify(response);
    });

    this.resolveTicket = () => {
      const confirm = getConfirmDialog(
        "Are you sure you want to resolve this ticket?"
      );

      this.$mdDialog.show(confirm).then(() => {
        this.Ticket.resolve(this.$stateParams.id).$promise.then(
          (response) => {
            this.ticket = this.TicketTransforms.justify(response);
            this.Events.emit(showNotificationEvent, {
              message: "Your ticket has been resolved successfully",
            });
          },
          (response) => this.Events.emit(errorEvent, response.data)
        );
      });
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/ticket/ticket.controller.js